/* eslint-disable no-unused-expressions */
const googleMapApiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

export const loadMapScript = () => {
  const id = 'google_map';
  if (document.getElementById(id)) return null;

  return new Promise(resolve => {
    const script = document.createElement('script');
    script.setAttribute('id', id);
    script.type = 'text/javascript';
    script.src = `https://maps.google.com/maps/api/js?key=${googleMapApiKey}&libraries=places`;
    const x = document.getElementsByTagName('script')[0];
    x.parentNode?.insertBefore(script, x);
    script.addEventListener('load', () => {
      resolve('loaded');
    });
  });
};
